// 卡片推送
import { ynToBool } from '@polyv/utils/src/boolean';
import { local } from '@polyv/utils/src/storage';
import { isMobile } from '@polyv/utils/src/browser';
import Polling from '@polyv/utils/src/polling';
import { ossCompress } from '@/assets/utils/utils';
import entryMixin from '@/assets/mixins/entry';
import langs from '@/assets/locale/lang/push-card';
import redpackBox from './images/icon-redpack.png';
import giftBox from './images/icon-gift.png';
import iconQrEntry from './images/icon-scan.png';
import { BEFORE_DESTROY } from '@/assets/utils/compat';
import { append } from '@polyv/utils/src/querystring';
import { isWebView } from '@polyv/web-view-bridge/is-webview';
import jsQr from 'jsqr';
import axios from 'axios';
import wechatMixin from '@/assets/mixins/wechat';

export default {
  langs,

  mixins: [entryMixin, wechatMixin],

  props: {
    pushCardSdk: {
      type: Object,
      default: null,
    },
    // 卡片入口提示文案位置：left/right
    tipPosition: {
      type: String,
      default: 'left'
    },
    // 是否禁用内部跳转
    linkSkipEnabled: {
      type: Boolean,
      default: true
    },
    // 观看倒计时结束后，是否自动打开卡片
    countdownAutoOpen: {
      type: Boolean,
      default: true
    },
    // 是否由内部去统计卡片打开情况
    internal: {
      type: Boolean,
      default: false
    },
    appendBody: {
      type: Boolean,
      default: false
    },
    iframeSize: {
      type: Object,
      default: () => {
        return {
          pcW: 720,
          pcH: 540,
          mobW: '100%',
          mobH: 460
        };
      }
    },
    /** 获取跳转链接附带参数 */
    getLinkParams: Function,

    /** 控制是否显示为二维码状态，webview不显示二维码 */
    initQrCode: {
      type: Boolean,
      default: true
    },

    /** 获取微信 SDK 对象 */
    getWeixinSdk: Function,
  },

  data() {
    return {
      // 房间号
      roomId: '',
      visible: false,
      // 卡片倒计时剩余时长
      remainingTime: 0,
      // 卡片信息
      cardInfo: {},
      // 圆环周长
      len: 0,
      // 上圆环（运动圆环）
      circle: null,
      // 卡片总时长
      totalTime: 0,
      // 卡片(自动关闭)倒计时器
      polling: null,
      // 卡片弹出倒计时器
      popUpPolling: null,
      // 距离卡片弹出剩余时间（秒）
      popUpLeftTime: 0,
      // 距离卡片弹出倒计时文案消息剩余时间（秒）
      countdownMsgHideLeftTime: 3,
      // 卡片是否在推送中
      onPushing: false,
      // 卡片ID
      cardId: '',
      // 获取卡片时间是否已返回
      getResidueTimeEnd: true,
      // 卡片弹窗是否已经插入到页面
      isAppend: false,
      iframeLink: '',
      iframeVisible: false,
      isMobile: isMobile(),
      showCardTime: null,
      pressTimer: null,
      copyToastVisible: false,
      /** 弹窗倒计时（秒） */
      countDownTime: 0,
    };
  },
  computed: {
    // 卡片推送入口显示隐藏
    entryVisible() {
      return (this.entranceEnabled || this.popUpLeftTime > 0) && this.onPushing;
    },
    // 卡片推送挂件文本或倒计时
    entryText() {
      if (this.popUpLeftTime > 0) {
        return this.convertSecondsToFormatted(this.countDownTime);
      }

      return this.isQrCode ? this.iarTrans('pushCard.popupLeftTips6') : this.iarTrans('pushCard.popupLeftTips5');
    },
    // 卡片样式
    cardStyle() {
      if (this.cardInfo.imageType === 'weixinWork' && !this.initQrCode) {
        return 'redpack';
      }
      // 二维码卡片自定义样式
      if (this.isCustomQr) {
        return 'weixinWork';
      }
      return this.cardInfo.imageType || 'redpack';
    },
    /** 是否二维码自定义卡片样式 */
    isCustomQr() {
      return this.cardInfo.imageType === 'custom' && this.isQrCode;
    },
    /** 二维码卡片自定义背景图 */
    customQrCardBgImgStyle() {
      return this.cardStyle === 'weixinWork' && this.cardImage ? `background-image: url(${this.cardImage})` : '';
    },
    // 卡片标题
    content() {
      return this.cardInfo.title;
    },
    // 点击卡片要跳转的链接
    link() {
      if (this.isQrCode || !this.isCommonLink) return '';
      return this.cardInfo.link;
    },
    // 有倒计时
    hasCountDown() {
      return this.cardInfo.duration > 0;
    },
    // 卡片是否立即弹出
    isPushCondition() {
      return this.cardInfo.showCondition === 'PUSH';
    },
    // 倒计时文案
    countdownMsg() {
      return this.cardInfo.countdownMsg;
    },
    // 是否有卡片推送入口
    entranceEnabled() {
      return ynToBool(this.cardInfo.enterEnabled || 'N');
    },
    // 没有入口，立即弹出时倒计时由服务端控制
    isShowByServer() {
      return !this.entranceEnabled && this.isPushCondition;
    },
    // 是否为自定义模板
    isCustomType() {
      return this.cardStyle === 'custom';
    },
    // 是否为扫码类型卡片
    isQrCode() {
      return this.cardInfo.cardType === 'qrCode' && this.initQrCode;
    },
    cardImage() {
      return this.cardInfo.cardImage;
    },
    qrCodeImage() {
      return this.cardInfo.qrCodeImage;
    },
    enterImage() {
      return this.cardInfo.enterImage;
    },
    qrCodeBoxImage() {
      return iconQrEntry;
    },
    iconUrl() {
      // 自定义
      if (this.isCustomType || this.isCustomQr) {
        return this.enterImage;
      }
      // 二维码默认
      if (this.isQrCode) {
        return this.qrCodeBoxImage;
      }
      // 普通卡片 - 礼物
      if (this.cardStyle === 'giftbox') {
        return giftBox;
      }
      // 普通卡片 - 红包
      return redpackBox;
    },
    isCardpushIframe() {
      return this.cardInfo.redirectType === 'iframe';
    },
    modalWidth() {
      return this.isMobile ? this.iframeSize.mobW : this.iframeSize.pcW;
    },
    modalHeight() {
      return this.isMobile ? this.iframeSize.mobH : this.iframeSize.pcH;
    },
    isCommonLink() {
      return this.cardInfo.hrefType !== 'multiplatform';
    },
    /**
      * 判断是否显示微信小程序按钮
      * 1. 微信浏览器环境
      * 2. 填写了原始 id
      * 3. 微信版本高于 7.0.12
      */
    isWeixinButton() {
      if (!this.cardInfo || !this.isMobile) {
        return false;
      }

      // 小程序 webview 内使用原生 sdk 功能跳转
      if (this.isWxMiniProgramWebview) {
        return false;
      }

      return (
        this.isWeixin &&
        this.cardInfo.wxMiniprogramOriginalId &&
        this.isHighWeixinVersion
      );
    },
    /** 普通卡片自定义类型标题新样式 */
    useNewCustomStyle() {
      return !!this.cardInfo.durationPosition && !this.isQrCode && this.cardInfo.imageType === 'custom';
    },
    /** 倒计时位置，兼容旧数据 */
    durationPosition() {
      return this.cardInfo.durationPosition || 'top';
    },
    /** 倒计时显示在顶部 */
    isCountDownPositionTop() {
      return this.durationPosition === 'top';
    },
    /** 倒计时显示在右上角 */
    isCountDownInRightTop() {
      return this.isCountDownPositionTop && !this.isQrCode;
    },
    /** 领取时间拆分为mm:ss数组 */
    popupTimeArr() {
      return this.convertSecondsFormattedToArray(this.convertSecondsToFormatted(this.countDownTime));
    },
    /** 倒计时文案 */
    remainingTimeTips() {
      return /^zh_/.test(this._useLang) ? `${this.remainingTime}s${this.iarTrans('pushCard.durationTips')}` : `${this.iarTrans('pushCard.durationTips')}${this.remainingTime}s`;
    },
  },

  watch: {
    entryVisible: {
      immediate: true,
      handler(val) {
        this.$emit('entry-visible-changed', val);
      }
    },
    pushCardSdk: {
      immediate: true,
      handler() {
        this.startHandler = this.onStart.bind(this);
        this.cancelHandler = this.onCancel.bind(this);
        this.getResidueTimeHandler = this.onGerResidueTime.bind(this);
        this.bindAppEvents();
      },
    },
    visible(newVal) {
      if (newVal) {
        this.showModal();
        this.showCardTime = new Date().getTime();
        if (this.hasCountDown && this.popUpLeftTime <= 0) {
          this.startPolling();
        }
      } else {
        // 主动关闭卡片弹窗，需要通知聊天室
        this.remainingTime = this.totalTime + 1;
        this.len = 0;
        this.stopPolling();
        if (this.showCardTime) {
          this.trackLogShowPushCard();
        }
        this.showCardTime = null;
      }
      this.$emit('visible-changed', newVal);
    },
    // 轮询剩余时长，更新倒计时
    remainingTime(newVal) {
      // 需要倒计时显示到0再隐藏
      if (newVal >= 0) {
        const newValue = this.len - (newVal / this.totalTime) * this.len;
        if (this.circle) {
          this.circle.style.strokeDashoffset = newValue;
        }
      } else {
        // 倒计时结束,停止轮询
        this.stopPolling(false);
        // 如果没有倒计时,则不关闭卡片
        if (!this.hasCountDown) return;
        this.handleClose();
      }
    },

    popUpLeftTime(val) {
      if (this.hasCountDown && val <= 0) {
        this.startPolling();
      }
    }
  },

  [BEFORE_DESTROY]() {
    if (this.$refs.cardModal && this.$refs.cardModal.parentNode) {
      this.$refs.cardModal.parentNode.removeChild(this.$refs.cardModal);
    }
    this.unbindAppEvents();
    this.stopPolling();
  },

  methods: {
    _getCoreSdk() {
      return this.pushCardSdk;
    },
    bindAppEvents() {
      const pushCardSdk = this.pushCardSdk;
      if (!pushCardSdk) { return; }
      pushCardSdk.on(pushCardSdk.events.START, this.startHandler);
      pushCardSdk.on(pushCardSdk.events.CANCEL, this.cancelHandler);
      pushCardSdk.on(pushCardSdk.events.GET_RESIDUE_TIME, this.getResidueTimeHandler);
    },

    unbindAppEvents() {
      const pushCardSdk = this.pushCardSdk;
      if (!pushCardSdk) { return; }
      pushCardSdk.off(pushCardSdk.events.START, this.startHandler);
      pushCardSdk.off(pushCardSdk.events.CANCEL, this.cancelHandler);
      pushCardSdk.off(pushCardSdk.events.GET_RESIDUE_TIME, this.getResidueTimeHandler);
    },

    onStart(data) {
      this.onPushing = true;
      this.cardId = data.id;
      this.roomId = data.roomId;
      this.handleClose();
      this.stopPolling(false);
      // 有倒计时
      if (data.time >= 0) {
        this.totalTime = data.total;
        // 解决卡片弹出后看到的时间少了一秒
        this.remainingTime = data.time + 1;
      }
      // 获取推送卡片数据
      this.getPushCardData();
    },

    onCancel() {
      this.onPushing = false;
      this.handleClose();
      this.stopPolling(false);
      this.popUpLeftTime = 0;
    },

    /** 监听卡片倒计时剩余时间 */
    onGerResidueTime(msg) {
      // 侦听剩余时长事件
      this.getResidueTimeEnd = true;
      const time = msg.data.time;
      this.remainingTime = time;
      if (time === 0) {
        this.stopPolling(false);
        // 如果没有倒计时,则不关闭卡片
        if (!this.hasCountDown) return;
        this.handleClose();
      }
    },

    startPolling() {
      this.stopPolling(false);
      this.initPolling();
      this.$nextTick(() => {
        if (this.circle) {
          this.len = 2 * Math.PI * this.circle.getAttribute('r');
        } else if (this.$refs.cardCirclePath) {
          this.circle = this.$refs.cardCirclePath;
          this.len = 2 * Math.PI * this.circle.getAttribute('r');
          this.circle.style.strokeDasharray = this.len;
        }
      });
    },

    // 轮询获取剩余时长
    initPolling() {
      const polling = this.polling = new Polling(() => {
        if (this.isShowByServer) {
          // 防止连续请求
          if (this.getResidueTimeEnd) {
            this.getResidueTimeEnd = false;
            this.pushCardSdk.getResidueTime();
          }
        } else {
          this.remainingTime--;
        }
      }, {
        interval: 1000
      });
      polling.start();
    },

    stopPolling(sendSocket = true) {
      if (this.polling) {
        this.polling.stop();
        this.polling = null;
      }
      // sendSocket=true且没有入口才需要通知
      if (this.pushCardSdk && sendSocket && !this.entranceEnabled) {
        this.pushCardSdk.toClose();
      }
    },

    ossCompress,

    formatLink(link) {
      if (link && typeof this.getLinkParams === 'function') {
        const res = this.getLinkParams(link);
        if (typeof res === 'object') {
          link = append(link, res);
        }
      }
      return link;
    },

    openNormalLink(link) {
      if (ynToBool(this.cardInfo.linkEnabled || 'Y') && link) {
        const { userInfo } = this.pushCardSdk;
        const { redirectType } = this.cardInfo;
        this.handleClose();
        if (this.linkSkipEnabled && !this.isCardpushIframe) {
          switch (redirectType) {
            case 'tab':
              window.open(link, '_blank', 'noopener');
              break;
            case 'current':
              window.location.href = link;
              break;
            default:
              window.open(link, '_blank', 'noopener');
          }
        }

        if (this.linkSkipEnabled && this.isCardpushIframe && this.cardInfo.hrefType === 'multiplatform') {
          window.open(link, '_blank', 'noopener');
          return;
        }

        this.handleOpen(link);
        this.$emit('open', {
          redirectType,
          link: link,
          cardId: this.cardId,
          userInfo
        });
      }
      this.trackLogClickPushCard();
    },

    /**
     * 调用微信 sdk 方法跳转到当前小程序的某个页面
     */
    async toWxMiniProgramNavigate() {
      if (!this.cardInfo) {
        return;
      }
      const url = this.formatLink(this.cardInfo.wxMiniprogramLink);
      console.info('跳转到小程序某个页面', url);
      await this.toWxMiniProgram(url, () => {
        this.handleClose();
      });
      const { userInfo } = this.pushCardSdk;
      this.handleOpen();
      this.$emit('open', {
        redirectType: this.cardInfo.redirectType,
        link: url,
        cardId: this.cardId,
        userInfo
      });
    },

    async toPlvWebviewBridge() {
      const { getPlvWebviewBridge, getPlvWebviewSmallWindowSize } = this._globalConfig;
      const { link } = this.cardInfo;

      const plvWebviewDataSize = getPlvWebviewSmallWindowSize?.() || { width: 90, height: 160 };

      const webviewBridge = await getPlvWebviewBridge?.();
      if (!webviewBridge) {
        return;
      }

      webviewBridge.sendData('clickProduct', {
        width: plvWebviewDataSize.width,
        height: plvWebviewDataSize.height,
        newPage: true,
        link,
        data: {},
      });
    },

    openLink() {
      const { getPlvWebviewBridge, isPlvWebview, getPlvWebviewSmallWindowSize } = this._globalConfig;
      const supportPlvWebview = isPlvWebview?.() || false;
      const { hrefType } = this.cardInfo || {};

      // 保利威 SDK Webview 下跳转
      if (supportPlvWebview) {
        let linkTo = '';
        const { link, mobileLink, mobileAppLink, wxMiniprogramOriginalId, wxMiniprogramLink } = this.cardInfo || {};

        switch (hrefType) {
          case 'common':
            linkTo = link;
            break;
          case 'multiplatform':
            linkTo = mobileAppLink || mobileLink;
            break;
        }

        // 非通用链接，将其余字段单独放到 data 供接入方使用
        let otherData = null;
        if (hrefType !== 'common') {
          otherData = {
            mobileLink: this.formatLink(mobileLink),
            wxMiniprogramOriginalId,
            wxMiniprogramLink: this.formatLink(wxMiniprogramLink),
            mobileAppLink: this.formatLink(mobileAppLink),
          };
        }

        this.toPlvWebviewBridge({
          link: this.formatLink(linkTo),
          data: otherData,
          getPlvWebviewSmallWindowSize,
          getPlvWebviewBridge,
        });
        return;
      }
      console.info('开始执行');
      if (this.isCommonLink) {
        console.info('开始执行openNormalLink');
        this.openNormalLink(this.formatLink(this.link));
        return;
      }

      // 小程序 webview 环境，利用微信 sdk 跳转指定页面
      if (this.isWxMiniProgramWebview && this.cardInfo.wxMiniprogramLink) {
        this.toWxMiniProgramNavigate();
        this.trackLogClickPushCard();
        return;
      }

      if (this.isMobile) {
        console.info('开始执行 isMobile ');
        this.openNormalLink(this.formatLink(this.cardInfo.mobileLink));
      } else {
        console.info('PC');
        this.openNormalLink(this.formatLink(this.cardInfo.pcLink));
      }
    },

    handleOpen(link) {
      if (!this.internal) return;
      const isObtain = local.get(`isObtain${this.roomId}${this.cardId}`);
      // 领取纪录，已经点击过不再发送纪录
      if (isObtain !== 'true') {
        this.obtainCard();
      }
      if (!this.isCardpushIframe || !link) return;
      this.iframeLink = link;
      this.iframeVisible = true;
      this.$nextTick(() => {
        const cardpushIframe = document.getElementById('cardpushIframe');
        cardpushIframe && cardpushIframe.contentWindow.document.body.addEventListener('touchMove', (e) => {
          e.preventDefault();
        });
        cardpushIframe && cardpushIframe.contentWindow.location.reload();
      });
    },

    async obtainCard() {
      try {
        const res = await this.pushCardSdk.obtainCard(this.roomId, this.cardId);
        if (res.code === 200) {
          local.set(`isObtain${this.roomId}${this.cardId}`, 'true');
        }
      } catch (error) {
        console.warn(error);
      }
    },

    handleClose() {
      this.visible = false;
      this.$emit('close');
    },

    // 获取推送卡片数据
    async getPushCardData() {
      const res = await this.pushCardSdk.getPushCardData(this.cardId, this.roomId);
      if (!res) return;
      this.cardInfo = res.data;
      // 当前弹出方式为马上弹出
      if (this.isPushCondition) {
        let __visible = true;
        if (typeof this.cardInfo.onlyShowEntrance !== 'undefined' && this.cardInfo.onlyShowEntrance) {
          __visible = false;
        }

        this.visible = __visible;
        this.popUpLeftTime = 0;
      } else {
        this.countdownMsgHideLeftTime = 3;
        // 本地需要记录观看时长
        const leftTime = local.get(`plv_push_card_${this.cardId}`);
        this.popUpLeftTime = leftTime ? Number(leftTime) : this.cardInfo.conditionValue / 1000;
      }
    },

    handleCountdown(time) {
      this.countdownMsgHideLeftTime -= 1;
      local.set(`plv_push_card_${this.cardId}`, time);
      this.countDownTime = time;
    },

    handleCountdownEnd() {
      this.popUpLeftTime = 0;
      if (this.countdownAutoOpen) {
        this.visible = true;
      }
    },

    handleEntrance() {
      this.visible = true;
      if (!this.isPushCondition) {
        this.countdownMsgHideLeftTime = 3;
      }
    },

    showModal() {
      // 解决祖先容器有transform的情况下，fixed定位失效问题
      this.$nextTick(() => {
        const target = this.$refs.cardModal;
        if (this.appendBody) {
          document.body.appendChild(target);
        }
      });
    },

    handleIframeClose() {
      this.iframeVisible = false;
    },

    trackLogShowPushCard() {
      const trackLogData = {
        event_id: 'user_read_push_card',
        event_cata: 'behavior',
        event_type: 'show',
        spec_attrs: {
          cardName: this.cardInfo.title,
          cardId: this.cardId,
          exposureTime: this.showCardTime,
          browseDurationTime: new Date().getTime() - this.showCardTime,
        }
      };
      this.pushCardSdk.trackLog(trackLogData);
    },
    trackLogClickPushCard() {
      const trackLogData = {
        event_id: 'user_click_push_card_bubble',
        event_cata: 'behavior',
        event_type: 'click',
        spec_attrs: {
          cardName: this.cardInfo.title,
          cardId: this.cardId,
          clickTime: new Date().getTime()
        }
      };
      this.pushCardSdk.trackLog(trackLogData);
    },

    onTouchStart() {
      if (!isWebView()) return;
      this.pressTimer = setTimeout(() => this.copyQrCode(this.qrCodeImage), 1000);
    },

    onTouchEnd() {
      if (!isWebView()) return;
      clearTimeout(this.pressTimer);
    },

    async copyQrCode(url) {
      console.info('trigger');

      try {
        const response = await axios.get(url, { responseType: 'arraybuffer' });
        // 将响应转化为Blob
        const blob = new Blob([response.data], { type: 'image/jpeg' });
        // 创建一个对象URL
        const imgURL = URL.createObjectURL(blob);

        // 创建一个Image对象
        const img = new Image();
        img.onload = async () => {
          // 当图片加载完成后，绘制到canvas并解析二维码
          const canvasElement = document.createElement('canvas');
          canvasElement.width = img.width;
          canvasElement.height = img.height;
          const canvasContext = canvasElement.getContext('2d');
          canvasContext.drawImage(img, 0, 0, img.width, img.height);
          const imageData = canvasContext.getImageData(0, 0, img.width, img.height);

          // 使用jsQR解析二维码
          const code = jsQr(imageData.data, img.width, img.height);
          if (code) {
            await navigator.clipboard.writeText(code.data);
            this.copyToastVisible = true;
            console.info('QR Code content:', code.data);
          } else {
            console.error('No QR Code found.');
          }

          // 释放对象URL
          URL.revokeObjectURL(imgURL);
        };
        img.src = imgURL;
      } catch (error) {
        console.error('Error while fetching and decoding QR code:', error);
      }
    },

    /** 弹窗倒计时转换 mm:ss */
    convertSecondsToFormatted(seconds) {
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = seconds % 60;
      return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
    },

    /** 弹窗倒计时转换 mm:ss, 拆解单个数字到数组 */
    convertSecondsFormattedToArray(secondsText) {
      return secondsText.split('').map(char => {
        if (char === ':') {
          return { type: 'block', value: char };
        } else {
          return { type: 'digit', value: parseInt(char) || 0 };
        }
      });
    }
  }
};
